import { ReactNode, RefObject, useLayoutEffect, useState } from 'react';
import styles from './DropDownList.module.scss';
import cx from 'classnames';
import { useOutsideClick } from 'hooks';

type Props = {
  isOpen: boolean;
  onClose: (event?: MouseEvent | undefined) => void;
  tableRef?: RefObject<HTMLDivElement>;
  children: ReactNode;
  position?: 'rightBottom';
};

export const DropDownListMenu = ({ isOpen, onClose, tableRef, position, children }: Props) => {
  const menuRef = useOutsideClick<HTMLDivElement>((event) => {
    onClose(event);
  });

  const [menuPosition, setMenuPosition] = useState<'bottom' | 'top' | 'rightBottom'>('bottom');
  useLayoutEffect(() => {
    if (position) {
      setMenuPosition('rightBottom');
      return;
    }
    if (tableRef && tableRef.current && menuRef.current) {
      const fromTopToBottomOfTable = tableRef.current.getBoundingClientRect().bottom;
      const fromTopToBottomOfMenu = menuRef.current.getBoundingClientRect().bottom;
      const menuIsNotVisible = fromTopToBottomOfTable - fromTopToBottomOfMenu < 0;
      if (menuIsNotVisible) {
        setMenuPosition('top');
        return;
      }
    }
    setMenuPosition('bottom');
  }, [menuRef, tableRef, isOpen]);

  if (!isOpen) return null;
  return (
    <div className={styles.backdrop}>
      <div ref={menuRef} className={cx(styles.menu, styles[menuPosition])}>
        {children}
      </div>
    </div>
  );
};
